import { ButtonGroup, Alert, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledAlert = styled(Alert) `
  margin-top: ${themeGet('spacing.xl')};
`;
export const StyledButtonGroup = styled(ButtonGroup) `
  white-space: nowrap;
  width: 100%;

  z-index: unset;

  justify-content: space-between;

  button {
    width: 100%;

    &:last-child {
      width: auto;
    }
  }
`;
export const RightAligned = styled.div `
  display: flex;
  margin-left: auto;
  align-items: center;
`;
